/* 設定產品高度 */
/* 內分產品高度(name_height)、特色高度(feature_height) */
export function setProductHeightSupport() {
  let initial_height = 0;
  let product_name_height = 0;
  let feature_name_height = 0;

  return {
    // 設定產品名稱高度
    setProductNameHeight: function (dom_selector) {
      product_name_height = 0;
    
      // 取得所有相同 class name 元素
      let dom_selector_list = document.querySelectorAll(dom_selector);
      dom_selector_list.forEach(function (dom) {

        // 判斷當前元素高度是否比前一元素高度高
        if (dom.offsetHeight > initial_height && dom.offsetHeight > product_name_height) {
          product_name_height = dom.offsetHeight;
        }
      });

      // 將所有相同 class name 元素設定為最高高度
      for (let i = 0; i < dom_selector_list.length; i++) {
        dom_selector_list[i].style.height = product_name_height + "px";
      }
    },

    // 設定產品特色高度 (邏輯與產品名稱高度相同)
    setFeatureNameHeight: function (dom_selector) {
      feature_name_height = 0;

      let dom_selector_list = document.querySelectorAll(dom_selector);
      dom_selector_list.forEach(function (dom) {
        if (
          dom.offsetHeight > initial_height &&
          dom.offsetHeight > feature_name_height
        ) {
          feature_name_height = dom.offsetHeight;
        }
      });

      for (let i = 0; i < dom_selector_list.length; i++) {
        dom_selector_list[i].style.height = feature_name_height + "px";
      }
    },
  };
}
